var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPriceModal)?_c('div',[_c('div',{staticClass:"guest-price-warning"},[_c('div',{staticClass:"container"},[_c('site-text-block',{staticClass:"big-modal",attrs:{"type":"guest_catalog_message"}}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.showPriceModal = false}}},[_vm._v(_vm._s(_vm.$t('guest_mode_warning_3')))])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }